<kehe-phoenix-tag
  classAttr="large"
  [tag]="{ text: status, bgColor: color }"
></kehe-phoenix-tag>
